import type * as type from "@vTypes"
import * as func from "@components/feature/roster_wanted/script"
import { useEffect, useRef, useState } from "react";
import { CircleX } from "lucide-react";

function PreferenceList(
    {
        preferenceData,
        setPreferenceData,
        nurseSchema_IdName,
        submittedStatus
    }: {
        preferenceData?: type.PreferenceData;
        setPreferenceData?: React.Dispatch<React.SetStateAction<type.PreferenceData | null>>;
        nurseSchema_IdName: { nurse_id: string, name: string }[];
        submittedStatus: string;
    }
) {
    const [isVerified, setIsVerified] = useState<boolean>(false);
    const [tempPassword, setTempPassword] = useState<string | undefined>();
    const [isOpendVerifyModal, setIsOpendVerifyModal] = useState<boolean>(false);
    const isInternalChange = useRef(false);

    // preferenceData가 외부(예: 저장 후 리로드)에서 변경될 때 isVerified 상태를 초기화하도록 적용하기 위함.
    // 내부에서 삭제 동작으로 인해 변경시에는 유지
    useEffect(() => {
        if (isInternalChange.current) {
            isInternalChange.current = false;
            return;
        }
        setIsVerified(false);
    }, [preferenceData]);


    const passwordComfirm = () => {
        if (tempPassword) {
            setIsVerified(true);
            setIsOpendVerifyModal(false);
            setTempPassword(undefined);
        } else {
            alert("비밀번호를 입력해주세요");
        }
    }
    useEffect(() => {
        if (isOpendVerifyModal) {
            (document.querySelector(".comp_inputPassword") as HTMLInputElement)?.focus();
        }
    }, [isOpendVerifyModal])

    const handleDelete = (e: React.MouseEvent, id: string) => {
        e.stopPropagation();
        if (!confirm("삭제하시겠습니까?")) return;
        isInternalChange.current = true;
        setPreferenceData?.(prev => {
            if (!prev) return null;
            return {
                ...prev,
                preference: prev.preference.filter(p => p.id !== id)
            };
        });
    };

    return (
        <div className="flex items-center">
            <div className={`text-[16px] font-semibold font-pretendard whitespace-nowrap w-[150px] ${isVerified ? 'mr-[4px]' : 'mr-[17px] '}`}>희망동료 (선호/비선호)</div>
            <div className={`flex gap-[17px] ${isVerified ? 'gap-x-[8px]' : 'gap-x-[17px]'} max-h-[130px] flex-wrap
         ${(preferenceData?.preference?.length || 0) > 3 ? 'max-w-[450px] p-2 overflow-auto' : ''}
                `}
            >
                {(preferenceData?.preference?.length ?? 0) > 0 ? (
                    preferenceData?.preference?.map((p, index) => {
                        const nurse = nurseSchema_IdName.find(n => n.nurse_id === p.id);
                        return (
                            <div key={index}
                                className={`w_myWanted__preferenceNurse ${p.weight > 0 && "__prefer"} relative group flex items-center`}
                                onClick={() => { if (!isVerified) setIsOpendVerifyModal(true); }}
                            >
                                <div className="w_myWanted__preferenceCategory font-semibold !w-[50px] !h-[30px] flex items-center justify-center">{p.weight > 0 ? '선호' : '비선호'}</div>
                                <div className={`w_myWanted__preferenceName font-semibold !h-[30px] !py-[5px] flex items-center ${isVerified ? '!w-[57px] !px-[7px]' : '!w-[68px] !px-[12px] '}`}>
                                    {isVerified ? nurse?.name : <span className="w_myWanted__preferenceName--lock">***</span>}
                                </div>
                                {isVerified && submittedStatus === "requested" &&
                                    <button
                                        type="button"
                                        className="!ml-1 w-5 h-5 rounded-full flex items-center justify-center z-10 hover:bg-[#777777]"
                                        onClick={(e) => handleDelete(e, p.id)}
                                    >
                                        <CircleX className="bg-white text-[#C2C2C2]" />
                                    </button>}
                            </div>
                        );
                    })

                ) : (<div className="w_myWanted__noPreference flex items-center justify-center"><span>희망하는 동료가 없습니다.</span></div>)
                }
            </div>

            {isOpendVerifyModal &&
                <div className="bg-white p-5 border border-[#d6d6de] rounded-[10px]shadow-[3px_3px_8px_0_rgba(0,0,0,0.15)] font-pretendard 
                text-center text-[14px] w-max
                fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1000]">
                    <div className="header">
                        <button type="button" className="modal_password_closeButton" onClick={() => { setIsOpendVerifyModal(false) }}></button>
                    </div>
                    <div className="body">
                        <div style={{ marginBottom: "12px" }}>희망동료(선호/비선호)의 이름을<br />확인하려면 비밀번호를 입력하세요.</div>

                        <div className="password_wrap">
                            <label className="password_textWrap">
                                password
                                <input type="password"
                                    className="comp_inputPassword"
                                    style={{ width: "100px" }}
                                    value={tempPassword}
                                    onInput={(e) => {
                                        const changeValue = e.currentTarget.value;
                                        setTempPassword(changeValue);
                                    }}
                                    onKeyDown={(e) => { func.handleKeydown(e as any, passwordComfirm) }}
                                />
                            </label>
                            <button type="button" className="comp_btn_confirm_circle"
                                onClick={passwordComfirm}
                            ></button>
                        </div>

                    </div>
                </div>
            }


        </div>
    )
}


export default PreferenceList